module.exports = "<br>\r\n<mat-slider  id=\"mySlider\"  style=\"width:70%;\" [(ngModel)]=\"date\" (onChange)=\"changeDate()\" thumbLabel min={{yearMin}} max={{yearMax}} step=\"1\"></mat-slider>"


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/time-slider/time-slider.component.html
// module id = ../../../../../src/app/time-slider/time-slider.component.html
// module chunks = main